import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Overview page components
import Header from "layouts/user-profile/Header";

import AuthService from "../../services/auth-service";

const UserProfile = () => {
  const [user, setUser] = useState({
    username: "",
    email: "",
    mobile: "",
  });

  const getUserData = async () => {
    try {
      const response = await AuthService.getProfile();
      console.log("Full getProfile API Response:", response);

      const userData = response?.data;

      if (!userData) {
        console.error("User data not found in response.");
        return;
      }

      setUser({
        username: userData.username || "",
        email: userData.email || "",
        mobile: userData.mobile || "",
      });
    } catch (error) {
      console.error("Failed to fetch profile:", error);
    }
  };

  useEffect(() => {
    getUserData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <Header mobile={user.mobile}>
        <MDBox mt={5} mb={3} px={2}>
          {/* Row 1: Field Names */}
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <MDTypography variant="h6" color="text" fontWeight="medium">
                Username
              </MDTypography>
            </Grid>
            <Grid item xs={12} md={4}>
              <MDTypography variant="h6" color="text" fontWeight="medium">
                Email
              </MDTypography>
            </Grid>
            <Grid item xs={12} md={4}>
              <MDTypography variant="h6" color="text" fontWeight="medium">
                Mobile
              </MDTypography>
            </Grid>

            {/* Row 2: Field Values */}
            <Grid item xs={8} md={4}>
              <MDTypography variant="body1" fontWeight="small" color="dark">
                {user.username}
              </MDTypography>
            </Grid>
            <Grid item xs={10} md={4}>
              <MDTypography variant="body1" fontWeight="small" color="dark">
                {user.email}
              </MDTypography>
            </Grid>
            <Grid item xs={10} md={4}>
              <MDTypography variant="body1" fontWeight="small" color="dark">
                {user.mobile}
              </MDTypography>
            </Grid>
          </Grid>
        </MDBox>
      </Header>
      <Footer />
    </DashboardLayout>
  );
};

export default UserProfile;
